import axios from 'axios'

const getFunctionEnvUrl = () => {
    /**
     * https://cli.vuejs.org/guide/mode-and-env.html#modes
     */ 
    return (process.env.NODE_ENV === 'production') ? 
        'https://europe-west1-chefsteinonline.cloudfunctions.net/' : 
        'http://localhost:5003/chefsteinonline/europe-west1/'
}

const getStripeCustomer = async (stripeCustomerId) => {
    return axios.get(getFunctionEnvUrl() + 'getStripeCustomer', { params: { customer_id: stripeCustomerId } })
}

const getStripeInvoices = async (stripeCustomerId) => {
    return axios.get(getFunctionEnvUrl() + 'getStripeInvoices', { params: { customer_id: stripeCustomerId }})
}

const getStripeSubscriptions = async (stripeCustomerId) => {
    return axios.get(getFunctionEnvUrl() + 'getStripeSubscriptions', { params: { customer_id: stripeCustomerId }})
}

const getStripePlans = async () => {
    return axios.get(getFunctionEnvUrl() + 'getStripePlans', { params: { active: true }})
}

const getStripeProducts = async () => {
    return axios.get(getFunctionEnvUrl() + 'getStripeProducts', { params: { active: true }})
}

const updateStripeSubscription = async (updateProps) => {
    return axios.post(getFunctionEnvUrl() + 'updateStripeSubscriptions', updateProps)
}

const getStripeCards = async (stripeCustomerId) => {
    return axios.get(getFunctionEnvUrl() + 'getStripeCards', { params: { customer_id: stripeCustomerId }})
}

const detachPaymentMethodFromStripeCustomer = async (paymentMethodId) => {
    return axios.post(getFunctionEnvUrl() + 'detachPaymentMethodFromStripeCustomer', { paymentMethodId: paymentMethodId })
}

const createPaymentMethodToStripe = async (createPaymentMethodProps) => {
    return axios.post(getFunctionEnvUrl() + 'createPaymentMethodToStripe', createPaymentMethodProps)
}

const attachPaymentMethodToStripeCustomer = async (attachPaymentMethodProps) => {
    return axios.post(getFunctionEnvUrl() + 'attachPaymentMethodToStripeCustomer', attachPaymentMethodProps)
}

const createCustomerToStripe = async (createCustomerProps) => {
    return axios.post(getFunctionEnvUrl() + 'createCustomerToStripe', createCustomerProps)
}

const createStripeSubscription = async (createSubscriptionProps) => {
    return axios.post(getFunctionEnvUrl() + 'createSubscriptionToStripe', createSubscriptionProps)
}

const getStripePaymentMethod = async (paymentMethodId) => {
    return axios.get(getFunctionEnvUrl() + 'getStripePaymentMethod', { params: { payment_method_id: paymentMethodId }})
}

export {
    getStripeCustomer,
    getStripeInvoices,
    getStripeSubscriptions,
    getStripePlans,
    getStripeProducts,
    updateStripeSubscription,
    getStripeCards,
    detachPaymentMethodFromStripeCustomer,
    createPaymentMethodToStripe,
    attachPaymentMethodToStripeCustomer,
    createCustomerToStripe,
    createStripeSubscription,
    getStripePaymentMethod,
}